enum VidServiceResponseStatus {
  ok = 'ok',
  corrected = 'ok corrected',
  incomplete = 'incomplete',
  not_found = 'not found',
}

export default VidServiceResponseStatus;
